import React from "react";
import { useTranslation } from "react-i18next";

interface ResultCountProps {
  total: number;
  isFiltered?: boolean;
  entity: string;
  filteredLabel?: string;
  className?: string;
}

const ResultCount: React.FC<ResultCountProps> = ({
  total,
  isFiltered = false,
  entity,
  filteredLabel,
  className = "",
}) => {
  const { t } = useTranslation();
  const defaultFilteredLabel = t("common.results", "results");
  const label = isFiltered ? (filteredLabel || defaultFilteredLabel) : entity;

  return (
    <span
      className={`shrink-0 whitespace-nowrap rounded-full bg-muted px-2 py-0.5 text-sm text-text-muted transition-opacity duration-200 ${className}`.trim()}
    >
      {total.toLocaleString("en-US")} {label}
    </span>
  );
};

export default React.memo(ResultCount);
